/**
 * Breaks the circular dependency main.js ↔ services/router.
 *
 * main.js calls setApp(app) after createApp().
 * HTTP error handlers and router guards read via getApp().
 */
let _app = null

export function setApp(app) {
  _app = app
}

export function getApp() {
  return _app
}

export function getGlobal(key) {
  return _app?.config?.globalProperties?.[key]
}

export function notify(payload) {
  const n = getGlobal('$notify')
  if (typeof n === 'function') n(payload)
}

export function getRoute() {
  return getGlobal('$route') || { path: '/', query: {} }
}

export function getRouter() {
  return getGlobal('$router')
}
